/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Size_VolumeInputs */

const en_field_size_volume = /** @type {(inputs: Field_Size_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size / Volume`)
};

const es_field_size_volume = /** @type {(inputs: Field_Size_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño / Volumen`)
};

const fr_field_size_volume = /** @type {(inputs: Field_Size_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille / Volume`)
};

const de_field_size_volume = /** @type {(inputs: Field_Size_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe / Volumen`)
};

const ja_field_size_volume = /** @type {(inputs: Field_Size_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイズ / 容量`)
};

const zh_field_size_volume = /** @type {(inputs: Field_Size_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`容量 / 体积`)
};

const ar_field_size_volume = /** @type {(inputs: Field_Size_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحجم / السعة`)
};

const id_field_size_volume = /** @type {(inputs: Field_Size_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukuran / Volume`)
};

const it_field_size_volume = /** @type {(inputs: Field_Size_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato / Volume`)
};

const ru_field_size_volume = /** @type {(inputs: Field_Size_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размер / Объем`)
};

const pt_field_size_volume = /** @type {(inputs: Field_Size_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho / Volume`)
};

const ko_field_size_volume = /** @type {(inputs: Field_Size_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크기 / 용량`)
};

/**
* | output |
* | --- |
* | "Size / Volume" |
*
* @param {Field_Size_VolumeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_size_volume = /** @type {((inputs?: Field_Size_VolumeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Size_VolumeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_size_volume(inputs)
	if (locale === "es") return es_field_size_volume(inputs)
	if (locale === "fr") return fr_field_size_volume(inputs)
	if (locale === "de") return de_field_size_volume(inputs)
	if (locale === "ja") return ja_field_size_volume(inputs)
	if (locale === "zh") return zh_field_size_volume(inputs)
	if (locale === "ar") return ar_field_size_volume(inputs)
	if (locale === "id") return id_field_size_volume(inputs)
	if (locale === "it") return it_field_size_volume(inputs)
	if (locale === "ru") return ru_field_size_volume(inputs)
	if (locale === "pt") return pt_field_size_volume(inputs)
	return ko_field_size_volume(inputs)
});